import { api } from "../utils/AuthManager";
import format from "date-fns/format";
import { startOfMonth, startOfYear } from "date-fns";
const GetEnergy = async (id, date, type, aggr) => {
  console.log(date);
  return api
    .get(`/api/energy_data/${parseInt(id)}/`, {
      params: {
        aggr: aggr,
        date:
          type === "day"
            ? format(date, "yyyy-MM-dd")
            : type === "month"
            ? format(startOfMonth(date), "yyyy-MM-dd")
            : type === "year" && format(startOfYear(date), "yyyy-MM-dd"),
        date_aggr: type,
      },
    })

    .then((res) => {
      return res;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export default GetEnergy;
